import React, { useEffect } from "react";
import pathway_with_contact_rect from "../assets/pathway_with_contact_rect.webp";

export default function Footer() {
  useEffect(() => {
    if (window.ml) {
      window.ml("account", "1545109");
    }

    // Override MailerLite button styles after form loads
    const styleButton = () => {
      const buttons = document.querySelectorAll('.ml-form-embedWrapper button, .embeddedForm button');
      buttons.forEach(btn => {
        btn.style.setProperty('background-color', '#457B9D', 'important');
        btn.style.setProperty('background', '#457B9D', 'important');
        btn.style.setProperty('border-radius', '0.5rem', 'important');
      });
    };

    // Run immediately and also watch for DOM changes
    const observer = new MutationObserver(styleButton);
    observer.observe(document.body, { childList: true, subtree: true });

    // Also run on interval briefly to catch late-loading elements
    const interval = setInterval(styleButton, 100);
    setTimeout(() => clearInterval(interval), 3000);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  return (
    <footer className="relative overflow-hidden bg-gradient-to-br from-gray-50 via-white to-blue-50">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-gradient-to-br from-[#457B9D]/20 to-[#E8998D]/20 blur-3xl" />
        <div className="absolute -left-20 bottom-10 h-64 w-64 rounded-full bg-gradient-to-br from-[#E8998D]/20 to-[#457B9D]/20 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-3 lg:gap-16">
          {/* Logo & Mission Section */}
          <div className="flex flex-col items-center justify-center space-y-6 lg:items-start">
            <img
              src={pathway_with_contact_rect}
              alt="Pathway Resource Center"
              className="h-auto w-56 rounded-2xl shadow-lg shadow-blue-100/50 ring-1 ring-gray-100 transition-transform duration-300 hover:scale-105"
              loading="lazy"
            />
            <div className="flex items-center gap-3">
              <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#457B9D]/30 to-transparent" />
              <span className="text-sm font-medium text-[#457B9D]">
                We're Here For You
              </span>
              <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#457B9D]/30 to-transparent" />
            </div>
          </div>

          {/* Mission Statement */}
          <div className="lg:col-span-2">
            <div className="rounded-3xl bg-white/60 p-8 shadow-md shadow-blue-100/30 ring-1 ring-gray-100 backdrop-blur-sm">
              <h3 className="mb-4 text-xl font-bold text-gray-800">
                Our Commitment
              </h3>
              <p className="leading-relaxed text-gray-700">
                We provide our services without discrimination to people of any
                age, race, income, nationality, religious affiliation,
                disability, or other arbitrary circumstances. Because we are
                pro-woman and a non-profit 501(c)3, we do not provide or refer
                for abortion services. We provide all of our services at no
                cost.
              </p>

              {/* Newsletter Embed */}
              <div className="mt-8">
                <h4 className="mb-4 text-lg font-semibold text-gray-800">
                  Stay Connected
                </h4>
                <div className="ml-embedded embeddedForm" data-form="niG4PN" />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 border-t border-gray-200 pt-8">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p className="text-center text-sm text-gray-600">
              &copy; {new Date().getFullYear()} Pathway Resource Center. All
              rights reserved.
            </p>
            <p className="text-sm text-gray-600">
              Made with care in Texarkana
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
